import React from 'react';
import {useHistory} from 'react-router-dom';
// import ReactTooltip from 'react-tooltip';
import {capitalize} from 'lodash';
import Tooltip from 'components/Tooltip';

const ListFiltersSourceBtn = (props) => {
    let history = useHistory();

    const {
        handleSelect, iconClasses, socialFilters, backgroundColor, type,
        activeEntity, count, loading, activeView, inHeader, name,
    } = props;


    const toggleEditMode = () => {
        type === 'google_ozmosys' ?
        history.push(`/edit-entity/${activeEntity.id}/google_news`)
        : history.push(`/edit-entity/${activeEntity.id}${type ? '/' + type : ''}`)
    };


    return (
        <div
            className={`home-page-filters__source-item ${inHeader ? 'home-page-filters__source-item--in-header' : ''}`}>
            {(activeEntity && socialFilters[type] !== null) ?
                <>
                    <Tooltip placement="bottom" wide tooltip={`Show/hide ${name} results`}>
                        <div style={{position: 'relative', cursor: 'pointer'}}
                             onClick={() => handleSelect(type)}>
                            <div className={`filter-icon ${name === 'Instagram' ? 'filter-icon--instagram' : ''}`}
                                 style={{backgroundColor: backgroundColor}}
                            >
                                <i className={iconClasses}/>
                            </div>
                            {socialFilters[type] === true &&
                            <div className={`filter-icon-checkmark ${name === 'Instagram' ? 'filter-icon--instagram' : ''}`} style={{backgroundColor: backgroundColor}}>
                                <i className="fas fa-check"/>
                            </div>
                            }
                        </div>
                    </Tooltip>
                </>
                :
                    <div style={{position: 'relative', cursor: 'pointer'}}
                         onClick={() => toggleEditMode(type)}>
                        <Tooltip placement="bottom" wide tooltip={`Add ${name} source`}>
                            <div
                                className={`filter-icon disabled-filter disabled-filter--with-hover-effect ${name === 'Instagram' ? 'filter-icon--instagram' : ''}`}
                            >
                                <i className="fas fa-plus hidden-plus"/>
                                <i className={`${iconClasses} other-icon`}/>
                            </div>
                        </Tooltip>
                    </div>
            }
            {(!loading && activeEntity && Number.isInteger(count) && ((socialFilters[type] !== null) ||
                activeView === 'savedSearches')) && <div className="filter-icon-count">{count}</div>}
        </div>

    );
};

export default ListFiltersSourceBtn;
